import {Outlet} from 'react-router-dom';

const DocumentViewer = () => {
  return <Outlet />;
};

export default DocumentViewer;
